<template>
  <div>
    <FiltersForBoardByReference
      v-if="isABoardByReference"
      @on-the-fly-filters-change="onTheFlyFilters = $event"
    />
    <FiltersForSuperBoard
      v-if="isSuperBoard"
      @on-server-filters-change="onServerFiltersChange"
      @on-the-fly-filters-change="onTheFlyFilters = $event"
    />
    <FiltersForMyBoard
      v-if="isMyBoard"
      @on-server-filters-change="onServerFiltersChange"
      @on-the-fly-filters-change="onTheFlyFilters = $event"
    />
    <div class="row mx-n1 vh-content flex-nowrap overflow-x-scroll">
      <Column
        v-for="column in columns"
        :key="column.id"
        :column="column"
        :show-actions="!!referenceId"
        @create-activity="onCreateActivityAction"
      >
        <ColumnContent
          :data-id="column.id"
          :column-value="column.value"
          :column-name="column.name"
          :kanban-id="kanbanId"
          :on-the-fly-filters="onTheFlyFilters"
          @select-activity="onSelectActivityAction"
        />
      </Column>
      <ActivitySidebar
        :show="sidebarConfig.show"
        :config="sidebarConfig"
        :kanban-id="kanbanId"
        :reference-id="referenceId"
        :reference-type="referenceType"
        :reference-number="referenceNumber"
        :activity-id="selectedActivity.id"
        @close="onCloseSidebar"
      />
      <b-overlay :show="columnsLoading" no-wrap/>
    </div>
    <div
      class="position-fixed download-button"
      v-if="!columnsLoading"
      v-tooltip="'Descargar como CSV'">
      <div>
        <b-button
          data-cy="download-list"
          class="badge-glow"
          variant="warning"
          @click="downloadData"
        >
          <feather-icon
            icon="DownloadIcon"
            size="20"
          />
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import Column from '@/febos/global/kanban/components/Column';
import ColumnContent from '@/febos/global/kanban/components/ColumnContent';
import ActivitySidebar from '@/febos/global/kanban/components/ActivitySidebar';
import FiltersForBoardByReference from '@/febos/global/kanban/components/FiltersForBoardByReference';
import FiltersForSuperBoard from '@/febos/global/kanban/components/FiltersForSuperBoard';
import FiltersForMyBoard from '@/febos/global/kanban/components/FiltersForMyBoard';
import { columns, columnsLoading, columnsActivities } from '@/febos/global/kanban/store/getters';
import { fetchActivities, fetchColumns, getCsvActivities } from '@/febos/global/kanban/store/actions';

export default {
  data() {
    return {
      selectedActivity: {},
      activitiesIndex: {},
      sidebarConfig: {},
      onTheFlyFilters: {}
    };
  },
  computed: {
    ...mapGetters('kanban', {
      columns: columns.name,
      columnsLoading: columnsLoading.name,
      columnsActivities: columnsActivities.name
    }),
    ...mapGetters('Usuario', [
      'currentUserId'
    ]),
    ...mapGetters('Empresas', [
      'companyId'
    ]),
    isABoardByReference() {
      return !!this.referenceId;
    },
    isMyBoard() {
      return this.kanbanId === this.currentUserId;
    },
    isSuperBoard() {
      return this.kanbanId === this.companyId;
    },
    defaultFilter() {
      return this.isMyBoard ? `usuarioAsignadoId:${this.currentUserId}` : '';
    }
  },
  methods: {
    ...mapActions('kanban', {
      fetchColumns: fetchColumns.name,
      fetchActivities: fetchActivities.name,
      getCsvActivities: getCsvActivities.name
    }),
    downloadData() {
      this.getCsvActivities(this.columnsActivities);
    },
    onServerFiltersChange(serverFilters) {
      const filters = [
        this.defaultFilter,
        serverFilters
      ]
        .filter((filter) => !!filter)
        .join('|');
      this.fetchActivities({
        kanbanId: this.kanbanId,
        referenceId: this.referenceId,
        filters
      });
    },
    onCreateActivityAction(column) {
      this.selectedActivity = {};
      this.sidebarConfig = {
        show: true,
        usingForm: true,
        column
      };
    },
    onSelectActivityAction(activity) {
      this.selectedActivity = activity;
      this.sidebarConfig = {
        show: true,
        usingForm: false
      };
    },
    onCloseSidebar() {
      this.selectedActivity = {};
      this.sidebarConfig = {};
      this.refreshColumns();
    },
    refreshColumns() {
      this.fetchColumns();
      this.fetchActivities({
        kanbanId: this.kanbanId,
        referenceId: this.referenceId,
        filters: this.defaultFilter
      });
    }
  },
  created() {
    this.refreshColumns();
  },
  components: {
    ActivitySidebar,
    Column,
    ColumnContent,
    FiltersForBoardByReference,
    FiltersForSuperBoard,
    FiltersForMyBoard
  },
  props: {
    kanbanId: { type: String, required: true },
    referenceId: String,
    referenceType: String,
    referenceNumber: String
  }
};

</script>

<style>
.download-button {
  bottom: 50px;
  right: 40px;
}
</style>
